export const NoopAction = {
    type: null,
};

export interface NoopActionType {
    type: null;
}
